import MonitoringTabs from '../screens/MonitoringTabs'
import { MONITORING_ROUTE } from './monitoringRoute'
import { ROLE, RouteWithAccessType } from './types'

const monitoringRoleManagement: RouteWithAccessType[] = [
  {
    route: MONITORING_ROUTE,
    exact: true,
    rolesListWithReadAccess: [ROLE.ADMIN],
    rolesListWithWriteAccess: [ROLE.ADMIN],
    requiredFeatures: ['monitoring.view'],
    // Each tab carries the route's own feature, deliberately — the page has ONE
    // feature covering all of it, and inventing per-tab features here would be a
    // permissions decision rather than a fix. Declaring them is what canAccessTab
    // needs: with no tabs it finds no tabConfig and refuses everyone, which left this
    // screen redirecting every visitor to /403 (BL-059).
    tabs: [
      {
        params: { page: 'requests' },
        rolesListWithReadAccess: [ROLE.ADMIN],
        rolesListWithWriteAccess: [ROLE.ADMIN],
        requiredFeatures: ['monitoring.view']
      },
      {
        params: { page: 'reserves' },
        rolesListWithReadAccess: [ROLE.ADMIN],
        rolesListWithWriteAccess: [ROLE.ADMIN],
        requiredFeatures: ['monitoring.view']
      },
      {
        params: { page: 'update' },
        rolesListWithReadAccess: [ROLE.ADMIN],
        rolesListWithWriteAccess: [ROLE.ADMIN],
        requiredFeatures: ['monitoring.view']
      },
      {
        params: { page: 'push' },
        rolesListWithReadAccess: [ROLE.ADMIN],
        rolesListWithWriteAccess: [ROLE.ADMIN],
        requiredFeatures: ['monitoring.view']
      },
      {
        params: { page: 'inventory-health' },
        rolesListWithReadAccess: [ROLE.ADMIN],
        rolesListWithWriteAccess: [ROLE.ADMIN],
        requiredFeatures: ['monitoring.view']
      },
      {
        params: { page: 'allocate-mismatch' },
        rolesListWithReadAccess: [ROLE.ADMIN],
        rolesListWithWriteAccess: [ROLE.ADMIN],
        requiredFeatures: ['monitoring.view']
      },
      {
        params: { page: 'payment-follow-ups' },
        rolesListWithReadAccess: [ROLE.ADMIN],
        rolesListWithWriteAccess: [ROLE.ADMIN],
        requiredFeatures: ['monitoring.view']
      }
    ],
    component: <MonitoringTabs />
  }
]

export default monitoringRoleManagement
